import { styled } from "../../../../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  height: "auto",
  width: "1000px",
  gap: "18px",
  paddingTop: "16px",

  "@media screen and (max-width: 1100px)": {
    width: "calc(100vw - 80px)",
    overflow: "scroll",
    height: "calc(100vh - 80px)",
  },
});

export const PatientPickerRow = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "0 45px",
  marginBottom: "4px",
});

export const PatientPickerLabel = styled("span", {
  fontFamily: "$openSans",
  fontSize: "13px",
  color: "$gray-80",
  fontWeight: 500,
  minWidth: "60px",
});

export const ContentContainer = styled("div", {
  height: "auto",
  width: "auto",
  margin: "0 22px 0 22px",
  padding: "28px 28px 16px 28px",
  backgroundColor: "$gray-20",
  borderRadius: "8px",
});

export const SelectSection = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  flexWrap: "wrap",
  marginBottom: "20px",
});

export const Title = styled("h1", {
  fontWeight: 500,
  fontSize: "$text-xl",
  lineHeight: "22px",
  paddingRight: "22px",
  paddingLeft: "45px",
  color: "$black",
});

export const SubmitContainer = styled("div", {
  display: "flex",
  gap: "40px",
  padding: "8px 22px 12px 35px",
  alignItems: "center",
});

export const CancelButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "-38px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },
});

export const TextAreaContainer = styled("div", {
  paddingLeft: "45px",
  paddingRight: "33px",
  marginBottom: "20px",
  position: "relative",

  "& .ql-toolbar": {
    marginBottom: "8px",
  },
});
